handleUpdateUser